import React, { useEffect, useState } from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from '@mui/material';
import { useTranslation } from '../../../app/LanguageContext';

export default function ConsignmentCloseDialog({
  open,
  mode,
  items,
  onClose,
  onConfirm,
  loading,
}) {
  const { translate } = useTranslation();
  const [qtyByItem, setQtyByItem] = useState({});

  useEffect(() => {
    if (!open) return;
    const initial = {};
    (items || []).forEach((item) => {
      initial[item.id] = '0';
    });
    setQtyByItem(initial);
  }, [open, items]);

  const handleClose = () => {
    setQtyByItem({});
    onClose();
  };

  const handleConfirm = () => {
    const payloadItems = (items || []).map((item) => ({
      item_id: item.id,
      qty_sold: Math.max(0, parseInt(qtyByItem[item.id], 10) || 0),
    }));
    onConfirm({ items: payloadItems });
  };

  const titleKey = mode === 'renew' ? 'consignment.renew_title' : 'consignment.finalize_title';
  const confirmKey = mode === 'renew' ? 'consignment.renew_confirm' : 'consignment.finalize_confirm';

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="md" fullWidth>
      <DialogTitle>{translate(titleKey)}</DialogTitle>
      <DialogContent>
        <Typography variant="body2" color="text.secondary" mb={2}>
          {translate('consignment.close_cycle_help')}
        </Typography>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>{translate('consignment.item_product')}</TableCell>
              <TableCell align="right">{translate('consignment.item_qty_sent')}</TableCell>
              <TableCell align="right">{translate('consignment.qty_sold_this_cycle')}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {(items || []).map((item) => (
              <TableRow key={item.id}>
                <TableCell>
                  <Typography variant="body2">{item.product_name}</Typography>
                  {item.product_sku_display && (
                    <Typography variant="caption" color="text.secondary">{item.product_sku_display}</Typography>
                  )}
                </TableCell>
                <TableCell align="right">{item.qty_sent}</TableCell>
                <TableCell align="right" sx={{ width: 120 }}>
                  <TextField
                    size="small"
                    type="number"
                    value={qtyByItem[item.id] ?? '0'}
                    onChange={(e) => setQtyByItem((prev) => ({
                      ...prev,
                      [item.id]: e.target.value.replace(/\D/g, '').slice(0, 6),
                    }))}
                    inputProps={{ min: 0, max: item.qty_sent }}
                  />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} disabled={loading}>{translate('common.cancel')}</Button>
        <Button variant="contained" onClick={handleConfirm} disabled={loading}>
          {translate(confirmKey)}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
